import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useAuth from '../hooks/useAuth'
import { db } from '../lib/supabase'

export default function PrivacyConsent() {
  const { t } = useTranslation('common')
  const { user, refreshProfile } = useAuth()
  const [agreed, setAgreed] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleAccept = async () => {
    if (!agreed) return
    setLoading(true)
    setError(null)
    try {
      await db.acceptPrivacyConsent(user.id)
      await refreshProfile()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-2xl animate-fadeIn">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary-50 text-primary-600 rounded-full flex items-center justify-center mx-auto mb-6 text-2xl">
            &#128274;
          </div>
          <h1 className="font-display text-3xl font-medium text-gray-800">
            {t('privacy.title')}
          </h1>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-sm">
          <div className="text-gray-600 whitespace-pre-line leading-relaxed mb-6 max-h-[50vh] overflow-y-auto pr-2">
            {t('privacy.text')}
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-4">
              {error}
            </div>
          )}

          <label className="flex items-start gap-3 p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-primary-300 hover:bg-gray-50 transition-all mb-6">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="w-5 h-5 accent-primary-500 mt-0.5 shrink-0"
            />
            <span className="text-gray-700 font-medium">
              {t('privacy.consentLabel')}
            </span>
          </label>

          <button
            onClick={handleAccept}
            disabled={!agreed || loading}
            className="w-full py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white rounded-xl font-semibold transition-all hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? t('buttons.processing') : t('buttons.continue')}
          </button>
        </div>
      </div>
    </div>
  )
}
